<template>
  <div class="TableBox" >
    <div class="screenBox screenBox1">
      <el-popover placement="bottom-end" width="300" trigger="click">
        <el-radio v-model="export_radio" label="1">导出单月消耗表</el-radio>
        <el-radio v-model="export_radio" label="2" style="margin-top:10px">导出多月消耗表</el-radio>
        <el-select v-if="export_radio == '2'" multiple style="margin-top:10px;width:200px" v-model="exportMonth"
          size='mini' filterable placeholder="选择月份">
          <el-option v-for="(item, index) in allMontList" :key="index" :label="item" :value="item">
          </el-option>
        </el-select>
        <div style="text-align: center;margin-top: 20px;">
          <el-button type="primary" @click="exportEvent" size="mini">确定</el-button>
        </div>
        <div slot="reference" class="batchDelete" style="float:right;margin-left:10px;">预约导出</div>
      </el-popover>

      <div class="refreshIcon batchDelete" style="float: right" @click="init({ page: 1 })">
        刷新
        <i class="el-icon-refresh"></i>
      </div>
      <el-select v-if="userInfo.role_id == 12 || userInfo.role_id == 15 || userInfo.role_id == 22" 
        style="float:right;width:120px;margin-right:10px;" v-model="if_unsettled" size='mini'
        @change="init({ page: 1 })" filterable placeholder="未完成结算订单">
        <el-option v-for="(item, index) in if_unsettled_list" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select style="float:right;width:100px;margin-right:10px;" v-model="if_invoice" size='mini'
        @change="init({ page: 1 })" filterable placeholder="是否开票">
        <el-option v-for="(item, index) in if_invoice_list" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <search-template page_name="总消耗表" :timeMonth='timeMonth' source="total" @search_event='search_event'>
    </search-template>
    <div class="operationUploadBox clear" style="margin:5px 0" v-if="userInfo.role_id == 10">
      <div class="batchDelete" @click="certificateImportFlag=true" v-if="userInfo.role_id == 10">财务普通凭证导入</div>
      <div class="batchDelete" @click="importFlag=true" v-if="userInfo.role_id == 10">季度返点收入导入</div>
    </div>
    <div class="operationUploadBox clear" style="margin-top:5px;display:flex"
      v-if="userInfo.role_id == 12 || userInfo.role_id == 22">
      <!-- 帐期 商务助理专享 -->
      <!-- <div class="batchDelete" style="width:120px" @click="extraUodateCost">帐期批量编辑</div> -->
      <div class="batchDelete" style="background:#FF9B3B;border-color:#FF9B3B;" @click="clearSelection">清空选中</div>
    </div>
    <ux-grid class="uxGridBox" ref="plxTable" :height="height"
      :checkboxConfig="{ checkMethod: selectable, highlight: true }" @selection-change="selectionChange"
      @table-body-scroll="scroll" show-footer-overflow="tooltip" show-overflow="tooltip" size="mini">
      <ux-table-column title="实际消耗月份" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100">
        <template v-slot="{ row }">{{ row.order_original_month }}</template>
      </ux-table-column>
      <ux-table-column title="当月实际消耗月份" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="130">
        <template v-slot="{ row }">{{ row.original_order_original_month }}</template>
      </ux-table-column>
      <!-- 回款日期、机构回款日期 商务助理 -->
      <template v-if="userInfo.role_id == 12 || userInfo.role_id == 15 || userInfo.role_id == 22">
        <ux-table-column type="checkbox" align="center" fixed="left" width="40" />
        <ux-table-column title="回款日期" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100">
          <template v-slot="{ row }">{{ row.collection_date }}</template>
        </ux-table-column>
        <ux-table-column title="机构回款日期" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100">
          <template v-slot="{ row }">{{ row.mcn_collection_date }}</template>
        </ux-table-column>
        <!-- 结算单审核相关信息 -->
        <template v-if="userInfo.role_id == 15 || userInfo.role_id == 22">
          <ux-table-column title="结算单Id" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100">
            <template v-slot="{ row }">{{ row.statements_id }}</template>
          </ux-table-column>
          <ux-table-column title="结算单审核通过日期" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="140">
            <template v-slot="{ row }">{{ row.verify_date }}</template>
          </ux-table-column>
        </template>
      </template>
      <ux-table-column v-for="item in columns" :key="item.id" :resizable="item.resizable" :field="item.prop"
        :title="item.label" :width="item.width" show-header-overflow='tooltip' :fixed="item.fixed" align="center" />
      
        <template v-if="userInfo.role_id == 12 || userInfo.role_id == 15 || userInfo.role_id == 22">
          <!-- 结算单审核相关信息 -->
          <template v-if="userInfo.role_id == 15 || userInfo.role_id == 22">
            <ux-table-column title="MCN结算单Id" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="120">
              <template v-slot="{ row }">{{ row.mcn_statements_id }}</template>
          </ux-table-column>
          <ux-table-column title="MCN结算单审核通过日期" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="180">
            <template v-slot="{ row }">{{ row.mcn_verify_date }}</template>
          </ux-table-column>
        </template>
      </template>
      <ux-table-column title="状态" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100"
        fixed="right">
        <template v-slot="{ row }">
          <span v-if="row.status < 3">未锁单</span>
          <div v-else>
            <span v-if="row.status == 3 && (row.cost_verify_status == 0 || !row.cost_verify_status)">媒介锁单</span>
            <span v-if="row.status == 4 && (row.cost_verify_status == 0 || !row.cost_verify_status)">财务锁单</span>
            <span v-if="row.cost_verify_status == 1">待媒介审核</span>
            <span v-if="row.cost_verify_status == 2">媒介通过</span>
            <span v-if="row.cost_verify_status == 3">媒介驳回</span>
            <span v-if="row.cost_verify_status == 4">财务通过</span>
            <span v-if="row.cost_verify_status == 5">财务驳回</span>
          </div>
        </template>
      </ux-table-column>
      <ux-table-column title="操作" align="center" :minWidth="(userInfo.role_id == 22 || userInfo.role_id == 12) ? 140 : 80" fixed="right">
        <template v-slot="{ row }">
          <!-- 帐期编辑:商务助理专享 -->
          <!-- <span v-if="userInfo.role_id == 12 || userInfo.admin_id == 53"
            style="color:#66c23a;cursor: pointer;margin-right:5px;" @click="extraUpdateEvent(row)">账期</span> -->
          <!-- 媒介和媒介审核编辑权限 -->
          <!-- 2023.07.07 新增"开发角色"可编辑 -->
          <template v-if="userInfo.role_id == 9 || userInfo.role_id == 13 || userInfo.role_id == 12">
            <span style="color:#ff9b3c;cursor: pointer;margin-right:5px;"
              v-if="row.status >= 3 && (row.cost_verify_status == 1 || row.cost_verify_status == 2)"
              @click="delVerifyOrder(row)">撤销</span>
            <span v-else>
              <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" @click="editRowEvent(row)">编辑</span>
            </span>
          </template>
          <span style="color:#5B7BFE;cursor: pointer;" @click="order_id = row.id; journalFlag = true;">记录</span>
        </template>
      </ux-table-column>
    </ux-grid>
    <div ref="pagination" class="paginationBox clear" style="height: 35px;">
      <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper" :total="total" />
      <div class="statBtn" @click="showStatistics">数据合计</div>
    </div>
    <!-- 底部总数--查看更对数据 -->
    <el-dialog title="数据合计" :visible.sync="moreTotalDataFlag" width="600">
      <div class="totalData">
        <div style="width:50%">
          <p>订单最终收入合计：{{ $formatNum(statisticsData.final_amount) }}</p>
          <p>订单成本消耗合计：{{ $formatNum(statisticsData.cost) }}</p>
          <p>后台实付成本金额合计：{{ $formatNum(statisticsData.actual_cost_sum) }}</p>
          <p>线下补款合计：{{ $formatNum(statisticsData.offline_subsidy_amount) }}</p>
          <p>总达人数：{{ $formatNum(statisticsData.red_count) }}</p>
          <p>流量助推合计：{{ $formatNum(statisticsData.traffic_boost_sum) }}</p>
          <p>流量助推返货总计：{{ $formatNum(statisticsData.traffic_boost_refund) }}</p>
          <p>流量助推现金总计：{{ $formatNum(statisticsData.traffic_boost_money) }}</p>
          <p>MCN返点及CA金额合计：{{ $formatNum(statisticsData.mcn_rebate) }}</p>
          <p>置顶费合计：{{ $formatNum(statisticsData.top_fee) }}</p>
          <p>当月毛利合计：{{ $formatNum(statisticsData.profit) }}</p>
          <p>当月毛利率：{{ statisticsData.gross_margin }}</p>
          <p>确认成本含税合计：{{ $formatNum(statisticsData.confirmed_cost_includes_tax) }}</p>
          <p>确认成本不含税合计：{{ $formatNum(statisticsData.confirmed_cost) }}</p>
        </div>
        <div style="width:50%">
          <p>已开票流量助推返点收入：{{ $formatNum(statisticsData.final_flow_boost_rebate_income) }}</p>
          <p>已开票消耗与置顶返点收入：{{ $formatNum(statisticsData.final_ratio_of_consumption_to_top_income) }}</p>
          <p>线下补款开票金额：{{ $formatNum(statisticsData.offline_cost_invoice_amount) }}</p>
          <p style="color:#5060a2">订单金额：{{ $formatNum(statisticsData.amount) }}</p>
          <p style="color:#5060a2">当月订单最终金额：{{ $formatNum(statisticsData.origin_amount) }}</p>
          <template v-if="statisticsData && statisticsData.platform_amount">
            <p v-for="(item, key) in statisticsData.platform_amount" style="color:#5060a2">{{ key }} -
              订单最终金额：{{ $formatNum(item) }}</p>
          </template>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moreTotalDataFlag = false" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 帐期编辑 -->
    <el-dialog title="帐期编辑" :visible.sync="extraUpdateFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox">
        <div class="dialogitem">
          <label>回款日期：</label>
          <el-date-picker v-model="date_of_collection" type="date" value-format="yyyy-MM-dd" size='mini'
            placeholder="选择回款日期">
          </el-date-picker>
        </div>
        <div class="dialogitem">
          <label>帐期：</label>
          <el-input style="width:220px" v-model="payment_days" clearable placeholder="请输入帐期" size='mini'></el-input>
        </div>
        <!-- <div class="dialogitem">
          <label>体外返点：</label>
          <el-input style="width:220px" v-model="ivrp" clearable placeholder="请输入体外返点" size='mini'></el-input>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="extraUpdateFlag = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="extraUpdate" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="editFlag" width="70%" top="10vh" :close-on-click-modal='false'>
      <total-edit v-if="editFlag" :editDataTotal='editData' @cancelToast='cancelToast' @emit_refresh="emit_refresh">
      </total-edit>
    </el-dialog>
    <!-- 查看日志 -->
    <el-dialog title="订单记录" :visible.sync="journalFlag" width="60%" top="10vh" :close-on-click-modal='false'>
      <journal v-if="journalFlag" @cancelToast='cancelToast' :order_id='order_id'></journal>
    </el-dialog>
    <el-dialog title="财务普通凭证导入" :visible.sync="certificateImportFlag" width="640px" :close-on-click-modal='false'
      custom-class="certificate-import-dialog" :show-close="true">
      <div class="import-dialog-content">
        <div class="import-hero">
          <div>
            <div class="import-hero-title">仅录入财务凭证字段，不修改季度返点收入金额</div>
            <div class="import-hero-desc">请使用总消耗表导出文件，至少保留一个可识别凭证字段表头。</div>
          </div>
          <el-popover
            placement="bottom-end"
            width="520"
            trigger="click"
            popper-class="quarter-column-popover"
          >
            <div class="column-help-content">
              <div class="column-help-title">可识别凭证列与 Excel 列号</div>
              <div class="column-help-note">列号按当前总消耗表导出顺序展示；程序实际以表头文字识别。</div>
              <div class="column-help-table">
                <div class="column-help-row column-help-head">
                  <span>列号</span>
                  <span>表头名称</span>
                  <span>用途</span>
                </div>
                <div
                  class="column-help-row"
                  v-for="item in certificateImportColumns"
                  :key="item.letter + item.name"
                >
                  <span class="column-letter">{{ item.letter }}</span>
                  <span>{{ item.name }}</span>
                  <span>{{ item.usage }}</span>
                </div>
              </div>
            </div>
            <el-button slot="reference" class="column-help-button" icon="el-icon-question" circle></el-button>
          </el-popover>
        </div>

        <div class="certificate-tip-list">
          <div class="certificate-tip-item">
            <span class="scenario-label">适用</span>
            <span>需要批量录入暂估凭证、确认凭证、返点收入凭证、返点支出凭证或 MCN 凭证。</span>
          </div>
          <div class="certificate-tip-item">
            <span class="scenario-label">不会</span>
            <span>不会录入或覆盖已开票返点收入，也不会反推已开票返点比例。</span>
          </div>
          <div class="certificate-tip-item">
            <span class="scenario-label">填写</span>
            <span>保留“任务id”“所属月份”，并在需要更新的凭证列填写凭证号或确认凭证。</span>
          </div>
        </div>

        <div class="operationUpload import-action-bar single-action-bar">
          <el-upload class="import-upload-btn" ref="certificateUpload" :action="URL.BASEURL + URL.orderImportCost"
            :on-success="uploadSuccess" :on-error="uploadError" :on-progress='uploadProgress' :data="{
              admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
              ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
              sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
              type: 5,
              import_mode: 'certificate'
            }" :show-file-list='false' :auto-upload="true" accept=".xlsx,.xls,.csv">
            <div class="batchDelete import-btn-primary" v-if="userInfo.role_id == 10">
              <i class="el-icon-upload2"></i>
              上传财务普通凭证
            </div>
          </el-upload>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="季度返点收入导入" :visible.sync="importFlag" width="720px" :close-on-click-modal='false'
      custom-class="quarter-rebate-import-dialog" :show-close="true">
      <div class="import-dialog-content">
        <div class="import-hero">
          <div>
            <div class="import-hero-title">先选择本次业务场景，再上传总消耗表导出文件</div>
            <div class="import-hero-desc">系统按第 1 行表头识别数据，列号仅用于在 Excel 中快速定位。</div>
          </div>
          <el-popover
            placement="bottom-end"
            width="520"
            trigger="click"
            popper-class="quarter-column-popover"
          >
            <div class="column-help-content">
              <div class="column-help-title">可识别列名与 Excel 列号</div>
              <div class="column-help-note">列号按当前总消耗表导出顺序展示；程序实际以表头文字识别。</div>
              <div class="column-help-table">
                <div class="column-help-row column-help-head">
                  <span>列号</span>
                  <span>表头名称</span>
                  <span>用途</span>
                </div>
                <div
                  class="column-help-row"
                  v-for="item in quarterRebateImportColumns"
                  :key="item.letter + item.name"
                >
                  <span class="column-letter">{{ item.letter }}</span>
                  <span>{{ item.name }}</span>
                  <span>{{ item.usage }}</span>
                </div>
              </div>
              <div class="column-compatible-title">兼容旧表头</div>
              <div
                class="column-compatible-row"
                v-for="item in quarterRebateCompatibleColumns"
                :key="item.current"
              >
                <span>{{ item.current }}</span>
                <i class="el-icon-arrow-left"></i>
                <span>{{ item.legacy }}</span>
              </div>
            </div>
            <el-button slot="reference" class="column-help-button" icon="el-icon-question" circle></el-button>
          </el-popover>
        </div>

        <div class="scenario-grid">
          <div
            v-for="item in quarterRebateActionList"
            :key="item.value"
            :class="['scenario-card', { active: quarterRebateAction === item.value }]"
            @click="quarterRebateAction = item.value"
          >
            <div class="scenario-card-title">
              <i :class="item.icon"></i>
              <span>{{ item.label }}</span>
            </div>
            <div class="scenario-line">
              <span class="scenario-label">适用</span>
              <span>{{ item.scene }}</span>
            </div>
            <div class="scenario-line">
              <span class="scenario-label">解决</span>
              <span>{{ item.solve }}</span>
            </div>
            <div class="scenario-line">
              <span class="scenario-label">填写</span>
              <span>{{ item.fill }}</span>
            </div>
          </div>
        </div>

        <div class="import-notice">
          <i class="el-icon-warning-outline"></i>
          <span>流量助推订单只填写“已开票流量助推返点收入”；非流量助推订单只填写“已开票消耗与置顶返点收入”。同一订单不要两列同时填写。</span>
        </div>

        <div class="operationUpload import-action-bar quarter-rebate-action-bar">
          <el-select
            v-model="quarterRebateAction"
            size="mini"
            placeholder="请选择导入类型"
          >
            <el-option
              v-for="item in quarterRebateActionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <div v-if="quarterRebateAction === 'second_import'" class="accounting-month-field">
            <span class="accounting-month-label">记账月份</span>
            <el-date-picker v-model="quarterRebateAccountingMonth"
              type="month" value-format="yyyy-MM" size="mini" :clearable="false" placeholder="请选择记账月份" />
          </div>
          <el-upload class="import-upload-btn" ref="upload" :action="URL.BASEURL + URL.orderImportCost" :before-upload="beforeQuarterRebateUpload"
            :on-success="uploadSuccess" :on-error="uploadError" :on-progress='uploadProgress' :data="{
              admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
              ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
              sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
              type: 5,
              import_mode: 'quarter_rebate',
              quarter_rebate_action: quarterRebateAction,
              quarter_rebate_accounting_month: quarterRebateAction === 'second_import' ? quarterRebateAccountingMonth : ''
            }" :show-file-list='false' :auto-upload="true" accept=".xlsx,.xls,.csv">
            <div class="batchDelete import-btn-primary" v-if="userInfo.role_id == 10">
              <i class="el-icon-upload2"></i>
              导入季度返点收入
            </div>
          </el-upload>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import columnsJson from '../json/total.js'
import searchTemplate from '../searchTemplate.vue'
import journal from '../orderJournal'
import totalEdit from './totalEdit'
export default {
  components: {
    totalEdit,
    searchTemplate,
    journal
  },
  data () {
    const previousMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 0)
    return {
      height: 0,
      columns: [],//表头
      scrollTop: 0,
      timeMonth: '',
      search_data: [],
      page: 1,
      total: 0,
      page_size: 50,
      moreTotalDataFlag: false,
      orderTotal: {},
      userInfo: {},
      order_id: '',
      journalFlag: false,
      editFlag: false,
      editData: {},
      extraUpdateFlag: false,
      date_of_collection: '',
      payment_days: '',
      ivrp: '',
      extra_id: '',
      if_invoice: 0,
      if_invoice_list: [
        { label: '不限', value: 0 },
        { label: '已开票', value: 1 },
        { label: '未开票', value: 2 },
      ],
      if_unsettled: 0,
      if_unsettled_list: [
        { label: '不限', value: 0 },
        { label: '未结算订单', value: 1 },
      ],
      selectionList: [],
      flag: false,
      multipleSelection: [],
      multipleSelection1: {},
      export_radio: "1",
      allMontList: [],
      exportMonth: [],
      statisticsData: {},
      execMediumList: [], // 执行媒介列表
      certificateImportFlag: false,
      importFlag: false,
      quarterRebateAction: 'first_confirm',
      quarterRebateAccountingMonth: previousMonth.getFullYear() + '-' + ('0' + (previousMonth.getMonth() + 1)).slice(-2),
      quarterRebateActionList: [
        {
          label: '第一次确认导入',
          value: 'first_confirm',
          icon: 'el-icon-document-add',
          scene: '财务第一次拿到季度返点确认金额，或需要按第一次确认口径重新导入确认金额。',
          solve: '录入第一次确认金额，并由系统反推已开票返点比例。',
          fill: '在对应“已开票...返点收入”列填写第一次确认金额。'
        },
        {
          label: '第二次开票导入',
          value: 'second_import',
          icon: 'el-icon-connection',
          scene: '订单已有第一次已开票返点收入，本次要补录剩余或第二批确认金额。',
          solve: '系统把本次单次金额与第一次金额累加，并校验是否接近预估总返点比例。',
          fill: '在对应“已开票...返点收入”列填写本次单次确认金额。'
        },
      ],
      quarterRebateImportColumns: [
        { letter: 'A', name: '任务id', usage: '必填，用于定位订单' },
        { letter: 'C', name: '所属月份', usage: '必填，用于定位订单月份' },
        { letter: 'BA', name: '已开票消耗与置顶返点比例', usage: '系统反推，可识别参考' },
        { letter: 'BB', name: '已开票消耗与置顶返点收入', usage: '非流量助推订单填写金额' },
        { letter: 'BC', name: '预估总消耗与置顶返点比例', usage: '可识别，辅助校验参考' },
        { letter: 'BD', name: '预估总消耗与置顶返点收入', usage: '可识别，辅助校验参考' },
        { letter: 'BE', name: '未开票消耗与置顶返点比例', usage: '可识别参考' },
        { letter: 'BF', name: '未开票消耗与置顶返点收入', usage: '可识别参考' },
        { letter: 'BG', name: '凭证号5(消耗与置顶返点收入暂估凭证)', usage: '可同步凭证字段' },
        { letter: 'BH', name: '消耗与置顶返点收入确认凭证', usage: '可同步凭证字段' },
        { letter: 'BI', name: '已开票流量助推返点比例', usage: '系统反推，可识别参考' },
        { letter: 'BJ', name: '已开票流量助推返点收入', usage: '流量助推订单填写金额' },
        { letter: 'BK', name: '预估总流量助推返点比例', usage: '可识别，辅助校验参考' },
        { letter: 'BL', name: '预估总流量助推返点收入', usage: '可识别，辅助校验参考' },
        { letter: 'BM', name: '未开票流量助推返点比例', usage: '可识别参考' },
        { letter: 'BN', name: '未开票流量助推返点收入', usage: '可识别参考' },
        { letter: 'BO', name: '凭证号6(流量助推返点收入暂估凭证)', usage: '可同步凭证字段' },
        { letter: 'BP', name: '流量助推返点收入确认凭证', usage: '可同步凭证字段' },
      ],
      quarterRebateCompatibleColumns: [
        { current: '已开票消耗与置顶返点收入', legacy: '开票消耗与置顶返点收入、累计开票消耗与置顶返点收入、最终消耗与置顶返点收入' },
        { current: '已开票流量助推返点收入', legacy: '开票流量助推返点收入、累计开票流量助推返点收入、最终流量助推返点收入' },
        { current: '预估总消耗与置顶返点收入', legacy: '消耗与置顶返点收入' },
        { current: '预估总流量助推返点收入', legacy: '流量助推返点收入' },
      ],
      certificateImportColumns: [
        { letter: 'A', name: '任务id', usage: '必填，用于定位订单' },
        { letter: 'C', name: '所属月份', usage: '必填，用于定位订单月份' },
        { letter: 'AC', name: '收入确认凭证', usage: '可识别凭证字段' },
        { letter: 'AE', name: '凭证号1(收入暂估凭证)', usage: '可识别凭证字段' },
        { letter: 'AN', name: '凭证号2(流量助推返货凭证)', usage: '可识别凭证字段' },
        { letter: 'AO', name: '凭证号3(后台实付成本合计暂估凭证)', usage: '可识别凭证字段' },
        { letter: 'AS', name: '确认成本凭证', usage: '可识别凭证字段' },
        { letter: 'AW', name: '凭证号4(补款暂估凭证)', usage: '可识别凭证字段' },
        { letter: 'AX', name: '补款确认凭证', usage: '可识别凭证字段' },
        { letter: 'BG', name: '凭证号5(消耗与置顶返点收入暂估凭证)', usage: '可识别凭证字段' },
        { letter: 'BH', name: '消耗与置顶返点收入确认凭证', usage: '可识别凭证字段' },
        { letter: 'BO', name: '凭证号6(流量助推返点收入暂估凭证)', usage: '可识别凭证字段' },
        { letter: 'BP', name: '流量助推返点收入确认凭证', usage: '可识别凭证字段' },
        { letter: 'BW', name: '凭证号7(返点支出暂估凭证)', usage: '可识别凭证字段' },
        { letter: 'BX', name: '返点支出确认凭证', usage: '可识别凭证字段' },
        { letter: 'CK', name: 'mcn凭证号 / MCN凭证号', usage: '可识别凭证字段' },
        { letter: 'CL', name: 'mcn确认凭证 / MCN确认凭证', usage: '可识别凭证字段' },
      ],
    }
  },
  created () {
    if (this.$route.query.month) {
      this.timeMonth = this.$route.query.month
    } else {
      var date = new Date();
      if (date.getMonth() === 0) { // 默认值为上个月份；月份为 0 时处理跨年问题
        this.timeMonth = (date.getFullYear() - 1) + '-' + '12'
      } else {
        this.timeMonth = date.getFullYear() + '-' + ((date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth()));
      }
    }
    this.columns = columnsJson.filter((v) => {
      return v.prop != 'change_month'
    })

  },
  mounted () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    // 仅表格滚动：根据实际可视高度计算表格高度
    this.$nextTick(() => {
      this.computeGridHeight()
      window.addEventListener('resize', this.computeGridHeight, { passive: true })
    })
    this.getAllMontListEvent()
    this.getExecMediumList() // 获取执行媒介列表
    this.init({ page: 1 })
  },
  beforeDestroy () {
    try {
      window.removeEventListener('resize', this.computeGridHeight)
    } catch (e) {}
  },
  methods: {
    computeGridHeight () {
      this.$nextTick(() => {
        try {
          const viewportH = window.innerHeight || document.documentElement.clientHeight
          const gridEl = this.$refs.plxTable && this.$refs.plxTable.$el
          const pagEl = this.$refs.pagination
          if (!gridEl) return
          const gridTop = gridEl.getBoundingClientRect().top
          const pagH = pagEl ? pagEl.offsetHeight : 56
          const gap = 16
          const footer = 38
          let h = Math.floor(viewportH - gridTop - pagH - gap - footer)
          if (h < 300) h = 300
          this.height = h

        } catch (e) {
          const h = document.documentElement.clientHeight - 320
          this.height = h > 400 ? h : 400
        }
      })
    },
    getAllMontListEvent () {//月份列表
      this.$axios.get(this.URL.BASEURL + this.URL.getAllMontList, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var data = res.rst;
          this.allMontList = data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    // 获取执行媒介列表
    getExecMediumList() {
      this.$axios.get(this.URL.BASEURL + this.URL.getExecMediumList).then((res) => {
        if (res && res.data && res.data.errno == "0") {
          var data = res.data.rst;
          this.execMediumList = data;
          // 更新执行媒介列的筛选选项
          this.columns.forEach((column) => {
            if (column.prop === 'exec_medium') {
              column.filters = data.map(item => ({
                text: item.real_name,
                value: item.id
              }));
            }
          })
        } else {
          this.$message({
            message: res.data ? res.data.err : '获取执行媒介列表失败',
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log('执行媒介接口请求失败:', error);
      })
    },
    exportEvent () {//导出
      if (this.export_radio == 1) {
        this.init({ page: 1, exportServer: true })
      } else {//导出多月
        if (!this.exportMonth || this.exportMonth.length == 0) {
          this.$message({
            message: '请选择导出的月份',
            type: 'warning'
          })
          return
        }
        this.init({ page: 1, exportServer: true, multiple_month: true })
      }
    },
    search_event (data) {
      this.search_data = data;
      this.init({ page: 1 })
    },

    beforeQuarterRebateUpload (file) {
      if (this.quarterRebateAction === 'second_import' && !this.quarterRebateAccountingMonth) {
        this.$message({ message: '请选择本次导入的记账月份', type: 'warning' })
        return false
      }
      file.quarterRebateAction = this.quarterRebateAction
      file.quarterRebateAccountingMonth = this.quarterRebateAction === 'second_import' ? this.quarterRebateAccountingMonth : ''
      return true
    },
    uploadSuccess (res, file, fileList) {
      this.$loading(this.$loadingConfig).close()
      if (res.errno == 6014) {
        file.quarterRebateAction = file.quarterRebateAction || (file.raw && file.raw.quarterRebateAction) || this.quarterRebateAction
        file.quarterRebateAccountingMonth = file.quarterRebateAccountingMonth || (file.raw && file.raw.quarterRebateAccountingMonth) || ''
        const confirmHint = this.getImportErrorHint(res.rst.error, '待确认信息')
        this.$confirm(confirmHint, res.err, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确认导入',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.confirmQuarterRebateImport(file)
        }).catch(() => {})
        return
      }
      if (res.errno == 0) {
        this.importFlag = false
        this.certificateImportFlag = false
        var not_exists = `<p>${res.rst.info ? res.rst.info : '导入成功！'}</p>`
        this.$alert(not_exists, res.err, {
          dangerouslyUseHTMLString: true
        });
      } else {
        var errHint = this.getImportErrorHint(res.rst.error)
        this.$alert(errHint, res.err, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭',
          callback: action => {
          }
        });
      }
    },
    getImportErrorHint (error, title) {
      if (!Array.isArray(error)) {
        return error
      }

      var errHint = `<p>${title || '有误字段'}：</p><ul>`
      error.forEach((item) => {
        errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
      })
      return errHint + '</ul>'
    },
    confirmQuarterRebateImport (file) {
      if (!file || !file.raw) {
        this.$message({
          message: '原导入文件已失效，请重新上传',
          type: 'warning'
        })
        return
      }

      const userInfo = JSON.parse(this.$cookie.getCookie('userInfo'))
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('admin_id', userInfo.admin_id)
      formData.append('ttl', userInfo.ttl)
      formData.append('sign', userInfo.sign)
      formData.append('type', 5)
      formData.append('import_mode', 'quarter_rebate')
      formData.append('quarter_rebate_action', file.quarterRebateAction || this.quarterRebateAction)
      formData.append('quarter_rebate_confirm', 1)
      formData.append('quarter_rebate_accounting_month', file.quarterRebateAccountingMonth || '')

      this.$loading(this.$loadingConfig)
      const uploadRequest = this.$axios.create({ timeout: 0 })
      uploadRequest.post(this.URL.BASEURL + this.URL.orderImportCost, formData).then((res) => {
        this.uploadSuccess(res.data, file, [])
      }).catch(() => {
        this.uploadError()
      })
    },
    uploadError (err, file, fileList) {
      this.$loading(this.$loadingConfig).close()
      this.$alert('上传失败', '服务器错误', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    uploadProgress () {//上传中
      this.$loading(this.$loadingConfig)
    },
    handleCurrentChange (val) {
      this.init({ page: val, selection: 'clear' })
    },
    init ({ page, exportFlag, selection, exportServer, multiple_month }) {
      if (!selection || selection != 'clear') {
        this.clearSelection()
      }
      var params = {
        page: page,
        pagesize: this.page_size,
        month: this.timeMonth,
        if_invoice: this.if_invoice
      }
      
      // 添加未完成结算订单筛选参数
      if (this.userInfo.role_id == 12 || this.userInfo.role_id == 15 || this.userInfo.role_id == 22) {
        params.if_unsettled = this.if_unsettled
      }
      if (exportFlag) {
        params.page = 1;
        params.pagesize = 10000
      } else {
        page = page ? page : 1;
        params.page = page;
        this.page = page;
      }
      if (this.search_data.length == 0) {
        params.month = this.timeMonth
      } else {
        this.search_data.forEach((item) => {
          if (item.property == 'if_public' || item.property == 'is_refund') {
            params[item.property] = item.values == '是' ? 1 : null
          } else if (item.property == 'exec_medium') {
            // 执行媒介需要从名称转换回ID，参数名为exec_medium_id
            const mediumIds = item.values.map(name => {
              const medium = this.execMediumList.find(m => m.real_name === name)
              return medium ? medium.id : name
            })
            params['exec_medium_id'] = mediumIds
          } else {
            params[item.property] = item.values
          }
        })
      }
      // if (this.if_invoice) {
      //   if (!params.mcn_handler && !params.handler || params.mcn_handler && params.mcn_handler) {
      //     this.$confirm('请选择经手人或mcn经手人，两者只能选其一', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }).then(() => {
      //     })
      //     return
      //   }

      // }
      this.$loading(this.$loadingConfig)
      let axios_api = this.URL.orderIndex;
      if (exportServer) {//后端导出
        axios_api = this.URL.orderIndexExport
      }
      if (multiple_month) {//导出多月
        params.multiple_month = this.exportMonth
      }
      this.$axios.get(this.URL.BASEURL + axios_api, {
        params
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          if (exportServer) {//后端导出
            this.$alert('导出预约成功，请稍后到【导出列表】下载文件！', '提示', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              callback: action => {
              }
            });
            this.exportMonth = []
          } else {
            var data = res.rst;
            if (exportFlag) {
              // 处理导出数据中的执行媒介字段
              const exportData = data.data.map(item => {
                if (item.exec_medium && this.execMediumList.length > 0) {
                  const medium = this.execMediumList.find(m => m.id === item.exec_medium)
                  if (medium) {
                    item.exec_medium = medium.real_name
                  }
                }
                return item
              })
              this.$exportOrder({ source: 'all', dataList: exportData, name: '消耗表' })
            } else {
              this.orderTotal = res.rst.orderTotal;
              this.total = data.pageInfo.total;
              // 处理执行媒介字段，将ID转换为名称显示
              this.datas = data.data.map(item => {
                if (item.exec_medium && this.execMediumList.length > 0) {
                  const medium = this.execMediumList.find(m => m.id === item.exec_medium)
                  if (medium) {
                    item.exec_medium = medium.real_name
                  }
                }
                return item
              })
              this.$refs.plxTable.reloadData(this.datas)
              this.$nextTick(() => {
                // 渲染后重算高度，保证分页始终可见
                this.computeGridHeight()
                if (this.multipleSelection1['page_' + this.page] && this.multipleSelection1['page_' + this.page].length != 0) {
                  var rows = [], arr = []
                  this.multipleSelection1['page_' + this.page].forEach((item) => {
                    arr.push(item.id)
                  })
                  rows = this.datas.filter((v) => {
                    return arr.indexOf(v.id) != -1
                  })
                  this.flag = false
                  this.toggleSelection(rows)
                } else {
                  this.flag = true
                }
              })
            }
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    scroll ({ scrollTop, scrollLeft }) {
      this.scrollTop = scrollTop
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach((row, index) => {
          this.$refs.plxTable.toggleRowSelection([
            {
              row: row,
              selected: true
            }
          ])
          if (index == rows.length - 1) {
            this.flag = true
          }
        });
      }
    },
    extraUodateCost () {//批量修改
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择要修改的订单',
          type: 'warning'
        })
        return
      }
      this.extraUpdateFlag = true;
    },
    selectable ({ row }) {//选择表格限制条件
      return true
    },
    clearSelection () {//清空选中
      this.$refs.plxTable.clearSelection();
      this.multipleSelection = [];
      this.multipleSelection1 = {};
      this.selectionList = []
    },
    selectionChange (row) {// 选中的行
      this.selectionList = row
      if (this.flag) {
        this.multipleSelection1['page_' + this.page] = this.selectionList;
        this.multipleSelection = [];
        for (var i in this.multipleSelection1) {
          this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
        }
      }
    },
    delVerifyOrder (data) {
      this.$confirm('确定要撤销此订单的修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.delVerifyOrder, {
          order_id: data.id,
          type: 2
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.init({ page: 1 })
          } else {
            this.$loading(this.$loadingConfig).close();
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close();
        })
      }).catch(() => {
      })
    },
    editRowEvent (row) {
      this.editFlag = true;
      this.editData = JSON.parse(JSON.stringify(row));
      this.editData.if_public = this.editData.if_public == '是' ? true : null
    },
    cancelToast () {
      this.editFlag = false;
      this.journalFlag = false;
    },
    emit_refresh () {//编辑成功
      this.editFlag = false;
      this.init({ page: this.page })
    },
    extraUpdateEvent (data) {//帐期编辑
      this.clearSelection()
      this.extra_id = data.id;
      this.date_of_collection = data.date_of_collection;
      this.payment_days = data.payment_days;
      this.ivrp = data.ivrp;
      this.extraUpdateFlag = true
    },
    extraUpdate () {//帐期编辑
      var arr = [];
      if (this.multipleSelection.length != 0) {
        this.multipleSelection.forEach((item) => {
          arr.push(item.id)
        })
      }
      this.$loading(this.$loadingConfig);
      this.$axios.post(this.URL.BASEURL + this.URL.extraUpdate, {
        id: arr.length != 0 ? arr : this.extra_id,
        date_of_collection: this.date_of_collection,
        payment_days: this.payment_days,
        // ivrp: this.ivrp, // 2023.12.29 删除"体外返点"字段
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.extraUpdateFlag = false
          this.init({ page: 1 })
        } else {
          this.$loading(this.$loadingConfig).close();
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close();
      })
    },
    showStatistics() {
      let params = {
        page: this.page,
        pagesize: this.page_size,
        month: this.timeMonth,
        if_invoice: this.if_invoice
      }
      
      // 添加未完成结算订单筛选参数
      if (this.userInfo.role_id == 12 || this.userInfo.role_id == 15 || this.userInfo.role_id == 22) {
        params.if_unsettled = this.if_unsettled
      }
      
      if (this.search_data.length > 0) {
        this.search_data.forEach((item) => {
          if (item.property == 'if_public' || item.property == 'is_refund') {
            params[item.property] = item.values == '是' ? 1 : null
          } else {
            params[item.property] = item.values
          }
        })
      }

      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.orderIndexStat, {
        params
      }).then((res) => {
        this.$loading(this.$loadingConfig).close();
        if (res.data && res.data.errno == '0') {
          this.statisticsData = res.data.rst;
          this.moreTotalDataFlag = true;
        } else {
          this.$message({
            message: res.data.err || '获取统计数据失败',
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close();
        this.$message({
          message: '获取统计数据失败',
          type: 'error'
        })
      })
    },
  },
}
</script>
  <style lang="scss" scoped>
  @import "@/assets/css/tableStyle.scss";

  .topOperation {
    display: flex;
    align-items: top;

    .screenBox {
      flex: 1;
    }
  }

  .TableBox {
    padding: 15px;
    background: #fff;
    margin-top: 15px;
  }

  .fileTemplate {
    font-size: 12px;
    margin-right: 10px;
    text-decoration: underline;
    margin: 8px 10px 0 0;
    color: #5b7bfe;
    display: block;
  }

  .batchDelete {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #5b7bfe;
    background: #5b7bfe;
    color: #fff;
    margin-right: 12px;
    cursor: pointer;
    padding: 0 4px;
    min-width: 120px;
    transition: all 0.3s ease;
    display: inline-block;
    box-sizing: border-box;
    
    &:hover {
      background: #4a6bfe;
      border-color: #4a6bfe;
      box-shadow: 0 2px 8px rgba(91, 123, 254, 0.3);
    }
    
    &:active {
      transform: translateY(1px);
    }
    
    // 弹窗内按钮样式
    &.import-btn-primary {
      width: 100%;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
      padding: 0 18px;
      min-width: auto;
      border-radius: 6px;
      background: #5b7bfe;
      border-color: #5b7bfe;
      box-shadow: none;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      
      i {
        font-size: 16px;
      }
      
      &:hover {
        background: #4a6bfe;
        border-color: #4a6bfe;
        box-shadow: 0 2px 8px rgba(91, 123, 254, 0.24);
      }
      
      &:active {
        transform: translateY(1px);
        box-shadow: none;
      }
    }
    
    &.import-btn-secondary {
      width: 100%;
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
      padding: 0 20px;
      min-width: auto;
      border-radius: 6px;
      background: #ffffff;
      border: 2px solid #5b7bfe;
      color: #5b7bfe;
      box-shadow: 0 2px 8px rgba(91, 123, 254, 0.15);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      
      i {
        font-size: 16px;
      }
      
      &:hover {
        background: #f0f4ff;
        border-color: #4a6bfe;
        color: #4a6bfe;
        box-shadow: 0 4px 12px rgba(91, 123, 254, 0.25);
        transform: translateY(-1px);
      }
      
      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 6px rgba(91, 123, 254, 0.2);
      }
    }
  }

  // 季度返点导入弹窗
  ::v-deep .quarter-rebate-import-dialog,
  ::v-deep .certificate-import-dialog {
    border-radius: 8px;

    .el-dialog__header {
      padding: 20px 24px 14px;
      border-bottom: 1px solid #edf0f7;
      
      .el-dialog__title {
        font-size: 17px;
        font-weight: 600;
        color: #202652;
      }
      
      .el-dialog__close {
        color: #909399;
        font-size: 20px;
        
        &:hover {
          color: #5b7bfe;
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
    }
  }

  .import-dialog-content {
    padding: 20px 24px 22px;
  }

  .import-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 16px;
    background: #f7f9ff;
    border: 1px solid #e5ebff;
    border-radius: 8px;
  }

  .import-hero-title {
    color: #202652;
    font-size: 15px;
    font-weight: 600;
    line-height: 22px;
  }

  .import-hero-desc {
    color: #6b7280;
    font-size: 12px;
    line-height: 20px;
    margin-top: 4px;
  }

  .column-help-button {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    padding: 0;
    color: #5b7bfe;
    border-color: #cdd7ff;
    background: #ffffff;

    &:hover,
    &:focus {
      color: #4a6bfe;
      border-color: #8fa2ff;
      background: #ffffff;
    }
  }

  .column-help-content {
    color: #303133;
  }

  .column-help-title {
    font-size: 14px;
    font-weight: 600;
    color: #202652;
    margin-bottom: 4px;
  }

  .column-help-note {
    color: #909399;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 10px;
  }

  .column-help-table {
    border: 1px solid #edf0f7;
    border-radius: 6px;
    overflow: hidden;
  }

  .column-help-row {
    display: grid;
    grid-template-columns: 56px 210px 1fr;
    min-height: 32px;
    border-bottom: 1px solid #edf0f7;
    font-size: 12px;

    &:last-child {
      border-bottom: none;
    }

    span {
      padding: 8px 10px;
      line-height: 18px;
      word-break: break-word;
      border-right: 1px solid #edf0f7;

      &:last-child {
        border-right: none;
      }
    }
  }

  .column-help-head {
    background: #f5f7fb;
    color: #202652;
    font-weight: 600;
  }

  .column-letter {
    color: #5b7bfe;
    font-weight: 600;
  }

  .column-compatible-title {
    color: #202652;
    font-size: 13px;
    font-weight: 600;
    margin: 12px 0 6px;
  }

  .column-compatible-row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #606266;
    font-size: 12px;
    line-height: 22px;

    i {
      color: #a8abb2;
      font-size: 12px;
    }
  }

  .scenario-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 14px;
  }

  .scenario-card {
    min-height: 176px;
    padding: 12px;
    border: 1px solid #edf0f7;
    border-radius: 8px;
    background: #ffffff;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    &:hover {
      border-color: #b8c5ff;
      box-shadow: 0 4px 12px rgba(32, 38, 82, 0.08);
    }

    &.active {
      border-color: #5b7bfe;
      background: #fbfcff;
      box-shadow: inset 0 0 0 1px #5b7bfe;
    }
  }

  .scenario-card-title {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #202652;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 10px;

    i {
      color: #5b7bfe;
      font-size: 16px;
    }
  }

  .scenario-line {
    color: #606266;
    font-size: 12px;
    line-height: 19px;
    margin-top: 7px;
    word-break: break-word;
  }

  .scenario-label {
    display: inline-block;
    min-width: 34px;
    height: 18px;
    line-height: 18px;
    margin-right: 6px;
    color: #5b7bfe;
    text-align: center;
    background: #eef3ff;
    border-radius: 4px;
  }

  .import-notice {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 12px;
    padding: 10px 12px;
    color: #8a5a00;
    font-size: 12px;
    line-height: 20px;
    background: #fff7e8;
    border: 1px solid #ffe0a8;
    border-radius: 6px;

    i {
      flex-shrink: 0;
      margin-top: 2px;
      color: #e6a23c;
    }
  }

  .certificate-tip-list {
    margin-top: 14px;
    padding: 12px;
    border: 1px solid #edf0f7;
    border-radius: 8px;
    background: #ffffff;
  }

  .certificate-tip-item {
    color: #606266;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .operationUpload.import-action-bar {
    display: grid;
    grid-template-columns: 180px 1fr;
    gap: 12px;
    align-items: center;
    margin: 16px 0 0;
    padding: 14px 0 0;
    border-top: 1px solid #edf0f7;

    .el-select {
      width: 100%;
    }

    .import-upload-btn,
    ::v-deep .el-upload {
      width: 100%;
      display: block;
    }
  }

  .operationUpload.single-action-bar {
    grid-template-columns: 1fr;
  }

  .operationUpload.quarter-rebate-action-bar {
    display: flex;
    flex-wrap: wrap;

    .el-select {
      flex: 0 1 180px;
      width: 180px;
      max-width: 100%;
    }

    .accounting-month-field {
      display: flex;
      flex: 1 1 240px;
      align-items: center;
      gap: 8px;
      min-width: 0;
    }

    .accounting-month-label {
      flex-shrink: 0;
      white-space: nowrap;
    }

    .el-date-editor.el-input {
      flex: 1;
      width: 0;
      min-width: 0;
    }

    .import-upload-btn {
      flex: 1 1 180px;
      min-width: 0;
    }

    ::v-deep .el-input__inner {
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input__icon {
      line-height: 36px;
    }

    &::after {
      display: none;
    }
  }

  // 通用 operationUpload 样式（非弹窗内）
  .operationUpload {
    margin-bottom: 14px;
    padding: 0 4px;
    clear: both;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    &::after {
      content: '';
      display: table;
      clear: both;
    }
  }

  .uxGridBox {
    margin-top: 5px;
  }

  .refreshIcon {
    margin-right: 10px;
    background: #67c23a;
    border-color: #67c23a;
  }

  .paginationBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: 10px;
    text-align: center;
    padding: 0 20px;
  }

  .statBtn {
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    background: #5B7BFE;
    color: #fff;
    cursor: pointer;
    position: absolute;
    right: 0;
    
    &:hover {
        opacity: 0.9;
    }
  }

  .totalData {
    color: #202652;
    font-size: 14px;
    font-weight: 500;
    line-height: 30px;
    display: flex;

    &:first-of-type {
      margin-top: -20px;
    }
  }

  .dialogitem {
    margin-bottom: 10px;

    label {
      display: inline-block;
      width: 80px;
      font-size: 14px;
    }
  }

.uploadFileButton {
  background: transparent;
  border: none;
  color: #5c7bfe;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 3px;
  border: 1px solid #5c7bfe;
}
  </style>



// WEBPACK FOOTER //
// src/components/Order/medium/totalTable.vue